var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('HeaderMain'),_c('message-display'),_c('message-modal'),_c('confirm-display'),_c('audio-file-select'),_c('datepicker-modal'),_c('transition',{attrs:{"name":"custom-classes-transition","enter-active-class":"animated fadeIn faster"}},[_c('router-view')],1),_c('audio-player')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }